// Constants for Messages
export const OTP_SENT_SUCCESS = "OTP resent successfully!";
export const OTP_PASTE_ERROR = "Please paste digits.";
export const GENERAL_ERROR_MESSAGE = "Something went wrong, Please try again.";
export const INVALID_URL_ERROR =
  "Please enter a valid URL";
export const DUPLICATE_URL_ERROR = "URL already exist";
export const API_KEY_CREATED = "API key created successfully!";
export const API_KEY_REMOVED = "API key removed successfully!";
export const PICKUP_DATE_PAST_ERROR = "Pickup Date cannot be earlier than today.";

// Password Messages
export const PASSWORD_VALIDATION_ERROR =
  "Password must be 8 characters long and include at least one lowercase letter, one uppercase letter, one number, and one special character.";
export const PASSWORD_MISMATCH_ERROR =
  "Password and Re-enter password do not match.";
export const SUCCESS_PASSWORD_CREATED = "Password created successfully!";
export const PASSWORD_UPDATED_CREATED = "Password updated successfully!";
export const CURRENT_PASSWORD_MATCH_ERROR =
  "Current password and New password should not be same.";
export const NEW_PASSWORD_MATCH_ERROR =
  "New password and Confirm password does not match.";

// Messages for the "activate a not-onboarded account" popup. Entity specific
// copy (heading, success, failure) is supplied by the listing's activate config.
export const ACTIVATE_ACCOUNT_MESSAGES = {
  PASSWORD_REQUIRED: "Password is required.",
  CONFIRM_PASSWORD_REQUIRED: "Confirm Password is required.",
  PASSWORD_MISMATCH: "Password and Confirm Password do not match.",
  PASSWORD_RULE_HINT:
    "Password must contain at least - 8 characters, 1 uppercase, 1 lowercase, 1 number, & 1 special character",
};

// Hazmat modal Messages
export const Hazmat_Message = {
  SUCCESS_ADD: "Hazmat added successfully!",
  SUCCESS_UPDATE: "Hazmat updated successfully!",
};

// Add note modal Messages
export const Add_Note_Messages = {
  SUCCESS_ADD: "Order note added successfully!",
  SUCCESS_UPDATE: "Order note updated successfully!",
  SUCCESS_DELETE: "Order note deleted successfully!",
};

// Order status modal Messages
export const ORDER_STATUS_MESSAGES = {
  SUCCESS_ADD: "Order status added successfully!",
  SUCCESS_UPDATE: "Order status updated successfully!",
};

// Vehicle type modal message
export const VEHICLE_TYPE_MESSAGES = {
  SUCCESS_ADD: "Vehicle Type added successfully!",
  SUCCESS_UPDATE: "Vehicle Type updated successfully!",
};

// Add Xcalarator Package modal Messages
export const ADD_XCELERATOR_MESSAGES = {
  SUCCESS_ADD: "Package Type Saved Successfully!",
  SUCCESS_UPDATE: "Package Type Updated Successfully!",
};

// Xcalarator service modal Messages
export const XCELERATOR_SERVICE_MESSAGES = {
  SUCCESS_ADD: "Xcelerator API created successfully!",
  SUCCESS_UPDATE: "Xcelerator API updated successfully!",
};
// Xcelerator Vehicle modal Messages
export const XCELERATOR_VECHILE_MESSAGES = {
  SUCCESS_ADD: "Vehicle added successfully!",
  SUCCESS_UPDATE: "Vehicle updated successfully!",
};

// Agent Profile Messages
export const AGENT_PROFILE_MESSAGES = {
  SUCCESS_UPDATE: "Agent Profile updated successfully!",
};

// Rep Management (My Rep List) Messages
export const REP_MESSAGES = {
  REP_ADD_SUCCESS: "Sales Rep added successfully!",
  REP_UPDATE_SUCCESS: "Sales Rep updated successfully!",
  REP_DELETE_SUCCESS: "Sales Rep deleted successfully!",
  REP_DELETE_HEADING: "Delete Sales Rep!",
  INVITATION_RESENT_SUCCESS: "Invitation Resent Successfully!",
  ACTIVE_LABEL: "Sales Rep",
  EMAIL_EXISTS: "Email is already registered!",
  REP_ACTIVATE_HEADING: "Activate Sales Rep",
  REP_ACTIVATE_NOTE: "You can also activate this sales rep immediately.",
  REP_ACTIVATE_SUCCESS: "Sales Representative has been activated successfully !",
  REP_ACTIVATE_FAILED: "Unable to activate the sales rep. Please try again.",
};

// Agent Request Messages
export const AGENT_REQUEST_MESSAGES = {
  SUCCESS_ADD: "Your request to add the agent has been sent to OmniMove. You will be informed once approved.",
  SUCCESS_UPDATE: "Your updated request has been sent to OmniMove. You will be informed once approved.",
  SUCCESS_UPDATE_ADMIN: "Agent request updated successfully.",
  SUCCESS_APPROVE: "Agent has been successfully approved and added to the system. An invitation email has been sent to the agent.",
  SUCCESS_REJECT: "Agent request has been successfully rejected.",
  SUCCESS_RESEND: "Your request has been resent to OmniMove. You will be informed once approved.",
};

// Agent List Messages
export const AGENT_LIST_MESSAGES = {
  AGENT_ACTIVATE_HEADING: "Activate Agent",
  AGENT_ACTIVATE_NOTE: "You can also activate this agent immediately.",
  AGENT_ACTIVATE_SUCCESS: "Agent activated successfully.",
  AGENT_ACTIVATE_FAILED: "Unable to activate the agent. Please try again.",
};

// Agent Add/Edit Messages
export const AGENT_ADDEDIT_MESSAGES = {
  SUCCESS_UPDATE: "Agent updated successfully!",
  SUCCESS_ADD: "Agent added successfully!",
  API_KEY_CREATED: "Api key created successfully!",
  API_KEY_REMOVED: "Api key removed successfully!",
  UPDATE_CONFIRM_HEADING: "Update Details!",
  UPDATE_CONFIRM_PARA: "update the changes",
  UNSAVED_CHANGES_HEADING: "Unsaved Changes!",
  UNSAVED_CHANGES_PARA:
    "You have not saved your changes, do you want to continue",
};

// User Profile Messages
export const USER_PROFILE_MESSAGES = {
  SUCCESS_UPDATE: "Profile updated successfully!",
  PHONE_UPDATE: "Phone Number updated",
};

// User Profile Messages
export const COMPANY_PROFILE_MESSAGES = {
  SUCCESS_UPDATE: "Company Profile updated successfully!",
};

// User Add/Edit Messages
export const USER_ADDEDIT_PROFILE_MESSAGES = {
  SUCCESS_UPDATE: "User updated successfully!",
  SUCCESS_ADD: "User added successfully!",
};

// Customer Add/Edit Messages
export const CUSTOMER_ADDEDIT_PROFILE_MESSAGES = {
  SUCCESS_UPDATE: "Customer user updated successfully!",
  SUCCESS_ADD: "Customer user added successfully!",
};

// CustomerS Add/Edit Messages
export const CUSTOMERS_ADD_MESSAGES = {
  SUCCESS_UPDATE: "Customer updated successfully!",
  SUCCESS_ADD: "Customer created successfully!",
  IMAGE_UPLOAD_ERROR: "Please upload less than 2MB image.",
  IMAGE_UPLOAD_VALIDATION: "Please upload JPEG/JPG/PNG file.",
  OPERATIONAL_ADDRESS_UPDATED: "Operational Information updated successfully!",
};
export const SHIPPING_LABEL_DOWNLOAD_SUCCESS = "Shipping Label has been downloaded successfully!";
export const NO_SHIPPING_LABEL_FOUND = "Label not available for this order!";

export const NO_BOL_FOUND = "BOL not available for this order!";
export const BOL_DOWNLOAD_SUCCESS = "BOL PDF has been downloaded successfully!";
export const REPORT_DOWNLOAD_SUCCESS =
  "Report has been downloaded successfully!";

export const BOL_RESEND_SUCCESS = "BOL Resend successfully!";

// Xcelerator Api Messages
export const XCELERATOR_ADD_API_MESSAGES = {
  SUCCESS_UPDATE: "Xcelerator api updated successfully!",
  SUCCESS_ADD: "Xcelerator api created successfully!",
};

export const SWITCH_CUSTOMER_MESSAGES = {
  SUCCESS_CHANGE: "Customer switched successfully!",
};

export const CUSTOMER_MARKUP_MESSAGES = {
  SUCCESS_UPDATE: "Customer Markup Saved Successfully!",
  SUCCESS_ADD: "Customer markup created successfully!",
};

//  Invoice Group
export const CUSTOMER_INVOICE_GROUP_MESSAGES = {
  SUCCESS_UPDATE: "Customer invoice group updated successfully!",
  SUCCESS_ADD: "Customer invoice group added successfully!",
  SUCCESS_DELETE: "Invoice group has been deleted successfully!",
  DELETE_NOT_ALLOWED: "An invoice is already created using this invoice group, so the invoice group cannot be deleted.",
  DELETE_CONFIRM_HEADING: "No Invoice Found !",
  DELETE_CONFIRM_PARA: "Do you want to delete the invoice group",
  DELETE_CHECK_ERROR: "Failed to check invoice group.",
  DELETE_ERROR: "Failed to delete invoice group.",
  INVOICE_EDI_HOST_NAME_REQUIRED: "Please enter Host Name.",
  INVOICE_EDI_USER_NAME_REQUIRED: "Please enter User Name.",
  INVOICE_EDI_PASSWORD_REQUIRED: "Please enter Password.",
  DEACTIVATED_CREATE: "The associated invoice group is deactivated. Please connect your respective customer to an existing active invoice group to create invoices.",
  DELETED_CREATE: "The associated invoice group is deleted. Please connect the respective customer to an existing active invoice group to create invoices.",
  DEACTIVATED_EDIT: "The associated invoice group is deactivated. Please connect your respective customer to an existing active invoice group to edit invoices.",
  DEACTIVATED_RESEND: "The associated invoice group is deactivated. Please connect your respective customer to an existing active invoice group to resend invoices.",
};

export const ORDER_INVOICE_GROUP_MESSAGES = {
  SUCCESS_UPDATE: "Order invoice updated successfully!",
  SUCCESS_ADD: "Order invoice added successfully!",
  RESEND_SUCCESS:
    "Selected invoices have been resent to the latest accounting contact email !",
  NO_VALID_INVOICE: "No valid invoice data found to resend.",
};

export const AGENT_HUB_MESSAGES = {
  SUCCESS_UPDATE: "Agent Hub Updated Successfully!",
  SUCCESS_ADD: "Agent Hub Added Successfully!",
};

export const AGENT_HUB_CUSTOMER_MESSAGES = {
  SUCCESS_ADD: "Agent hub customer added successfully!",
  SUCCESS_UPDATE: "Agent hub customer updated successfully!",
  LTL_SUCCESS_SAVE: "Agent customer Saved successfully!",
};

export const FINAL_MILE_AGENT_MESSAGES = {
  SUCCESS_SAVE: "Final mile agent details saved successfully!",
};

export const AGENT_HUB_ZIP_MESSAGES = {
  SUCCESS_SAVE: "Service zip saved successfully!",
  SUCCESS_DELETE: "Service zip deleted successfully!",
  SUCCESS_DELETE_ALL: "All service zip codes have been deleted successfully!",
  ERROR_DELETE_ALL: "Failed to delete all service zips",
  ERROR_DELETE_ALL_FALLBACK: "Error deleting all service zip codes",
};

export const AGENT_HUB_LTL_ZIP_MESSAGES = {
  SUCCESS_SAVE: "Zip Code has been saved successfully!",
  SUCCESS_DELETE: "Zip Code has been deleted!",
  ERROR_DELETE: "Failed to delete zip",
};

export const AGENT_RATE_MESSAGES = {
  RATE_SAVE_SUCCESS: "Rate Saved Successfully!",
  RATE_ACTIVATE_SUCCESS: "Rate Activated successfully!",
  RATE_DEACTIVATE_SUCCESS: "Rate Deactivated successfully!",
  AGENT_ID_MISSING: "Agent ID is missing!",
  MILE_ZONE_SAVE_SUCCESS: "Mile zones saved successfully!",
  MILE_ZONE_DELETE_SUCCESS: "Mile zone deleted successfully!",
  WEIGHT_ZONE_SAVE_SUCCESS: "Weight zones saved successfully!",
  WEIGHT_ZONE_DELETE_SUCCESS: "Weight zone deleted successfully!",
};

export const AGENT_API_MESSAGES = {
  LOGIN_DETAILS_SAVE_SUCCESS: "Login Details Saved Successfully!",
  SERVICE_DELETE_SUCCESS: "Service deleted successfully!",
  PACKAGE_TYPE_DELETE_SUCCESS: "Package Type deleted successfully!",
  ORDER_STATUS_DELETE_SUCCESS: "Order Status deleted successfully!",
  VEHICLE_DELETE_SUCCESS: "Vehicle deleted successfully!",
  AGENT_API_DELETE_SUCCESS: "Agent API deleted successfully!",
  XCELERATOR_PACKAGE_DELETE_SUCCESS:
    "Xcelerator package deleted successfully!",
};

export const CUSTOMER_MANAGEMENT_MESSAGES = {
  ADDRESS_DELETE_SUCCESS: "Address deleted successfully!",
  ADDRESS_BOOK_UPDATE_SUCCESS: "Address book updated successfully!",
  ADDRESS_BOOK_ADD_SUCCESS: "Address book created successfully!",
  CUSTOMER_DELETE_SUCCESS: "Customer deleted successfully!",
  CUSTOMER_ACTIVE_LABEL: "Customer",
  CUSTOMER_USER_DELETE_SUCCESS: "Customer User deleted successfully!",
  CUSTOMER_USER_ACTIVE_LABEL: "Customer User",
  INVITATION_RESENT_SUCCESS: "Invitation Resent Successfully!",
  CUSTOMER_ACTIVATE_HEADING: "Activate Customer",
  CUSTOMER_ACTIVATE_NOTE: "You can also activate this customer immediately.",
  CUSTOMER_ACTIVATE_SUCCESS: "Customer activated successfully.",
  CUSTOMER_ACTIVATE_FAILED:
    "Unable to activate the customer. Please try again.",
  ITEM_DELETE_SUCCESS: "Item Has Been Successfully Deleted!",
  ITEM_LOAD_ERROR: "Unable to load item details.",
  ITEM_CUSTOMER_REQUIRED:
    "Please select a Customer (and Sub Customer if required).",
  ITEM_HANDLING_UNIT_REQUIRED: "Please select a Handling Unit Type.",
  ITEM_UPDATE_SUCCESS: "Customer Item Updated successfully!",
  ITEM_ADD_SUCCESS: "Customer Item Created Successfully!",
  CUSTOMER_ADDITIONAL_CHARGES_DELETE_SUCCESS:
    "Customer Additional Charges deleted successfully!",
  CUSTOMER_ADDITIONAL_CHARGES_LABEL: "Customer Additional Charges",
  CUSTOMER_MARKUP_DELETE_SUCCESS: "Customer markup deleted successfully!",
  CUSTOMER_MARKUP_LABEL: "Customer markup",
  SERVICE_LEVEL_MARKUP_DELETE_SUCCESS:
    "Service Level Markup Deleted Successfully!",
  AGENT_MARKUP_DELETE_SUCCESS: "Agent Markup Deleted Successfully!",
  FSC_CUSTOMER_DELETE_SUCCESS: "FSC customer deleted successfully!",
  CUSTOMER_MILE_ZONE_ADD_SUCCESS: "Customer mile zones added successfully!",
  CUSTOMER_MILE_ZONE_DELETE_SUCCESS: "Mile zone deleted successfully!",
  CUSTOMER_MILE_ZONE_LABEL: "Mile zone",
  CUSTOMER_WEIGHT_ZONE_ADD_SUCCESS: "Agent weight zones added successfully!",
  CUSTOMER_WEIGHT_ZONE_DELETE_SUCCESS: "Weight zone deleted successfully!",
  CUSTOMER_WEIGHT_ZONE_LABEL: "weight zone",
  CUSTOMER_RATE_SAVE_SUCCESS: "Rate saved successfully!",
  CUSTOMER_RATE_ACTIVATE_SUCCESS: "Rate Activated Successfully!",
  CUSTOMER_RATE_DEACTIVATE_SUCCESS: "Rate Deactivated Successfully!",
  CUSTOMER_ID_MISSING: "Customer ID is missing!",
  LOCATION_SELECT_REQUIRED: "Please select a location",
  LOCATION_CUSTOMER_ID_REQUIRED: "Customer ID is required",
  LOCATION_ADD_SUCCESS: "Location added successfully!",
  LOCATION_UPDATE_SUCCESS: "Location updated successfully!",
  LOCATION_FETCH_ERROR: "An error occurred while fetching location data",
  FINAL_MILE_INTEGRATION_UPDATE_SUCCESS: "Integration Updated successfully!",
  FINAL_MILE_INTEGRATION_LINK_SUCCESS:
    "Integration successful! Your account has been successfully linked with Dickerson Final Mile.",
  FINAL_MILE_INTEGRATION_CREATE_ERROR: "Failed to create Final Minal API Key",
  FINAL_MILE_INTEGRATION_FAILURE:
    "Integration failed. Please ensure Dickerson has added your account setup and configuration before linking.",
  FINAL_MILE_INTEGRATION_LOAD_ERROR:
    "An error occurred while loading data",
  LTL_INTEGRATION_UPDATE_SUCCESS: "Integration details updated successfully.",
  LTL_INTEGRATION_ADD_SUCCESS: "Integration added successfully.",
  LTL_INTEGRATION_CREATE_ERROR: "Failed to create LTL API Key",
  LTL_INTEGRATION_SAVE_ERROR:
    "An error occurred while saving the LTL API Key",
  LTL_INTEGRATION_LOAD_ERROR: "An error occurred while loading data",
  INVOICE_DETAILS_UPDATE_SUCCESS: "Invoice details updated successfully!",
  ONWARD_CREDENTIALS_UPDATE_SUCCESS: "Credentials updated successfully!",
  ONWARD_INTEGRATION_CONFIG_SUCCESS:
    "Integration configured successfully!",
};

export const EMAIL_MESSAGES = {
  OPERATIONAL_EMAIL_EXIST: "Operational email already exist.",
  CONTACT_EMAIL_EXIST: "Contact email already exist.",
  ACCOUNTING_EMAIL_EXIST: "Accounting email already exist.",
};

export const CUSTOMER_ADDITIONAL_CHARGES_MESSAGES = {
  SUCCESS_UPDATE: "Customer Additional Charges updated successfully!",
  SUCCESS_ADD: "Customer Additional Charges added successfully!",
  BULK_DELETE_SELECTED_SUCCESS:
    "Selected additional charges have been successfully removed!",
  BULK_DELETE_ALL_SUCCESS:
    "All additional charges have been successfully removed!",
};
// Customer Management → Customers → Tech Fee (Decisions D7, D8, D13, D17).
export const TECH_FEE_MESSAGES = {
  SUCCESS_ADD: "Tech Fee created successfully!",
  SUCCESS_UPDATE: "Tech Fee updated successfully!",
  // Shared Table active toggle: "Deactivate Tech Fee!" / "Tech Fee deactivated successfully!"
  LABEL: "Tech Fee",
  ACTIVE_HEADING: "Tech Fee!",
  CHARGE_MASTER_MISSING:
    "Technology Fee charge not found! A Tech Fee can't be saved without it.",
};
export const AGENT_ADDITIONAL_CHARGES_MESSAGES = {
  SUCCESS_UPDATE: "Agent Additional Charges updated successfully!",
  SUCCESS_ADD: "Agent Additional Charges added successfully!",
  BULK_DELETE_SELECTED_SUCCESS:
    "Selected additional charges have been successfully removed!",
  BULK_DELETE_ALL_SUCCESS:
    "All additional charges have been successfully removed!",
};

export const MODAL_MESSAGES = {
  SERVICE_MAP_EXISTS_ERROR: "Service Map Already Exists!",
  SERVICE_MAP_ADD_SUCCESS: "Service added successfully!",
  SERVICE_MAP_UPDATE_SUCCESS: "Service updated successfully!",
  SYSTEM_SERVICE_SAVE_SUCCESS: "Service saved successfully!",
  SYSTEM_SERVICE_UPDATE_SUCCESS: "Service updated successfully!",
  PACKAGE_TYPE_SAVE_SUCCESS: "Package type saved successfully!",
  PACKAGE_TYPE_UPDATE_SUCCESS: "Package type updated successfully!",
  INVOICE_PDF_OPEN_ERROR: "Failed to open invoice PDF.",
};

export const TABLE_MESSAGES = {
  INVOICE_DOWNLOAD_SUCCESS: "Invoice downloaded successfully!",
  NO_FINALIZED_ORDER_FOUND: "No Finalized Data Order Found!",
};

export const PROFILE_SECTION_MESSAGES = {
  EMAIL_NOTIFICATION_UPDATE_SUCCESS:
    "Notification setting updated successfully!",
  DEFAULT_CUSTOMER_FETCH_ERROR: "Failed to fetch customers.",
  DEFAULT_CUSTOMER_UPDATE_SUCCESS: "Default customer updated successfully!",
  DEFAULT_CUSTOMER_UPDATE_ERROR: "Failed to update default customer.",
  USER_PROFILE_MODAL_SUCCESS: "Profile has been updated successfully!",
};

export const REPORT_MESSAGES = {
  SAVE_SUCCESS: "Report Saved successfully!",
  SAVE_AND_SEND_SUCCESS: "Report Saved and Sent successfully!",
};

export const USERS_MESSAGES = {
  DELETE_SUCCESS: "User deleted successfully!",
  ACTIVE_LABEL: "User",
  INVITATION_RESENT_SUCCESS: "Invitation Resent Successfully!",
};
// SCAC modal message
export const SCAC_MESSAGES = {
  SUCCESS_ADD: "SCAC added successfully!",
  SUCCESS_UPDATE: "SCAC updated successfully!",
};

export const REPORT_FILE_GENERATING_MESSAGE = "Your report is being generated. Please try again shortly!";

// Service Configuration Messages
export const SERVICE_CONFIG_MESSAGES = {
  EMAIL_TEMPLATE_ADD_SUCCESS: "Email Template Added Successfully!",
  EMAIL_TEMPLATE_UPDATE_SUCCESS: "Email Template Updated Successfully!",
  EMAIL_TEMPLATE_DELETE_SUCCESS: "Email Template Deleted Successfully!",
  EMAIL_CONFIG_SAVE_SUCCESS: "Email configuration saved successfully!",
  EMAIL_CONFIG_UPDATE_SUCCESS: "Email configuration updated successfully!",
  EMAIL_INVALID_ADDRESS: "Please enter a valid email address",
  EMAIL_INVALID: "Please enter valid email",
  REGION_ADD_SUCCESS: "Region added successfully!",
  REGION_UPDATE_SUCCESS: "Region updated successfully!",
  REGION_DELETE_SUCCESS: "Region deleted successfully!",
  REGION_DELETE_HEADING: "Delete Region!",
  REGION_DELETE_CONFIRM: "Are you sure you want to delete this Region?",
  ONWARD_ORDER_STATUS_ADD_SUCCESS:
    "Onward order status name added successfully!",
  ONWARD_ORDER_STATUS_UPDATE_SUCCESS:
    "Onward order status name updated successfully!",
  FSC_LOCATION_PRICE_UPDATE_SUCCESS:
    "FSC Location price updated successfully!",
  FSC_LOCATION_PRICES_UPDATE_SUCCESS:
    "FSC Location prices updated successfully!",
  SERVICE_DELETE_SUCCESS: "Service deleted successfully!",
  SERVICE_DELETE_HEADING: "Delete Service!",
  SCAC_DELETE_SUCCESS: "SCAC deleted successfully!",
  SCAC_DELETE_HEADING: "Delete SCAC!",
  VEHICLE_TYPE_DELETE_SUCCESS: "Vehicle Type deleted successfully!",
  VEHICLE_TYPE_DELETE_HEADING: "Delete Vehicle Type!",
  ZIP_CODE_ADD_SUCCESS: "Zip code added successfully!",
  ZIP_CODE_UPDATE_SUCCESS: "Zip code updated successfully!",
  ZIP_CODE_DELETE_SUCCESS: "Zip code deleted successfully!",
  ZIP_CODE_DELETE_HEADING: "Delete Zip Code!",
  ZIP_CODE_DELETE_CONFIRM: "Are you sure you want to delete this zip code?",
  ZIP_CODE_BULK_DELETE_ALL_SUCCESS: "All zip codes removed successfully!",
  ZIP_CODE_BULK_DELETE_SELECTED_SUCCESS: "Selected zip codes removed successfully!",
  ZIP_CODE_BULK_DELETE_ALL_HEADING: "Remove All Zip Codes!",
  ZIP_CODE_BULK_DELETE_SELECTED_HEADING: "Remove Selected Zip Codes!",
  ZIP_CODE_BULK_DELETE_ALL_CONFIRM: "All zip codes will be permanently removed",
  ZIP_CODE_BULK_DELETE_SELECTED_CONFIRM: "Selected zip codes will be permanently removed",
  ZIP_CODE_STATUS_UPDATE_SUCCESS: "Zip code status updated successfully!",
  ZIP_CODE_STATUS_UPDATE_HEADING: "Update Zip Code Status",
};

// Helpdesk mailbox messages
export const MAILBOX_MESSAGES = {
  ADD_SUCCESS: "Mailbox added successfully!",
  SETTINGS_UPDATE_SUCCESS: "Mailbox settings updated successfully!",
  AUTH_ALL_PASSED: "SPF, DKIM and DMARC all passed!",
  AUTH_NOT_PASSED: "Verification finished. Some checks have not passed yet; DNS changes can take a few hours to propagate!",
  DNS_RECORDS_COPIED: "DNS records copied to clipboard!",
  DNS_RECORDS_COPY_FAILED: "Unable to copy, please copy the records manually!",
  UNBLOCK_SUCCESS: "Email address unblocked successfully!",
  UNBLOCK_TITLE: "Unblock Email Address!",
  unblockConfirm: (email: string) =>
    `Are you sure you want to unblock ${email}? It will be removed from the blocked addresses list.`,
  ADDRESS_REQUIRED: "Email Address is required",
  SHOWS_AS_REQUIRED: "User name (Shows As) is required",
};

// Helpdesk groups & assignment messages
export const HELPDESK_GROUP_MESSAGES = {
  ASSIGNMENT_UPDATE_SUCCESS: "Assignment settings updated successfully!",
  AVAILABILITY_UPDATE_SUCCESS: "Availability updated successfully!",
  LEAD_UPDATE_SUCCESS: "Lead updated successfully!",
  CAP_INVALID: "Enter 0 or a positive whole number",
  GROUP_ADD_SUCCESS: "Group created successfully!",
  NAME_REQUIRED: "Group name is required",
  NAME_TOO_LONG: "Group name cannot exceed 100 characters",
  ASSIGNMENT_REQUIRED: "Please select an assignment method",
  MEMBER_ADD_SUCCESS: "Member added successfully!",
  MEMBERS_ADD_SUCCESS: "Members added successfully!",
  MEMBER_REMOVE_SUCCESS: "Member removed successfully!",
  MEMBERS_REQUIRED: "Please select at least one member",
  MEMBERS_LOAD_FAILED: "Couldn't load members.",
  GROUP_NOT_FOUND: "Group not found!",
  UNSAVED_CHANGES_HEADING: "Unsaved Changes!",
  UNSAVED_CHANGES_PARA: "You have not saved your changes, do you want to continue",
  REMOVE_MEMBER_TITLE: "Remove a Member!",
  removeMemberConfirm: (name: string) =>
    `Are you sure you want to remove ${name} from the group? This action cannot be undone.`,
};

// Helpdesk SLA policy messages
export const HELPDESK_SLA_MESSAGES = {
  TARGET_UPDATE_SUCCESS: "SLA target updated successfully!",
  ESCALATION_UPDATE_SUCCESS: "Escalation updated successfully!",
  DURATION_INVALID: "Use a number and unit, e.g. 30 min, 4 hours, 2 days",
  PRIORITY_REQUIRED: "Please select a priority",
  HOURS_REQUIRED: "Please select hours",
  targetRequired: (label: string) => `${label} is required`,
};

// Helpdesk business hours messages
export const HELPDESK_HOURS_MESSAGES = {
  CALENDAR_ADD_SUCCESS: "Business hours calendar created successfully!",
  CALENDAR_UPDATE_SUCCESS: "Business hours calendar updated successfully!",
  DEFAULT_UPDATE_SUCCESS: "Default calendar updated successfully!",
  DEFAULT_REQUIRED: "One calendar must stay the default. Turn on Default for another calendar instead!",
  CALENDAR_NOT_FOUND: "Calendar not found!",
  NAME_REQUIRED: "Please enter calendar name",
  NAME_TOO_LONG: "Calendar name must be at most 100 characters",
  TIMEZONE_REQUIRED: "Please select time zone",
  SCHEDULE_INVALID: "Please fix the business hours",
  DAYS_REQUIRED: "Select at least one working day",
  TIME_INVALID: "Enter a valid time (HH:MM)",
  RANGE_INVALID: "Start time must be earlier than end time",
  SLOTS_OVERLAP: "Time slots overlap. Adjust them so they don’t overlap.",
  HOLIDAY_ADD_SUCCESS: "Holiday added successfully!",
  HOLIDAY_NAME_REQUIRED: "Please enter holiday name",
  HOLIDAY_NAME_TOO_LONG: "Holiday name must be at most 100 characters",
  HOLIDAY_DATE_REQUIRED: "Please select date",
  HOLIDAY_REMOVE_SUCCESS: "Holiday removed successfully!",
  HOLIDAY_REMOVE_TITLE: "Remove Holiday!",
  holidayRemoveConfirm: (name: string, date: string) =>
    `Are you sure you want to remove the holiday ${name} scheduled for ${date}?`,
  GROUP_HOURS_UPDATE_SUCCESS: "Group business hours updated successfully!",
  MEMBER_HOURS_ADD_SUCCESS: "Individual member business hours added successfully!",
  MEMBER_HOURS_UPDATE_SUCCESS: "Individual member business hours updated successfully!",
  MEMBER_HOURS_REMOVE_SUCCESS: "Individual member business hours removed successfully!",
  MEMBER_HOURS_REMOVE_TITLE: "Remove Individual Business Hours!",
  memberHoursRemoveConfirm: (memberName: string) =>
    `Are you sure you want to remove the individual business hours for ${memberName}? The member will follow the applicable group or default business hours.`,
  MEMBER_NOT_FOUND: "Member business hours not found!",
  MEMBERS_REQUIRED: "Please select at least one member",
  UNSAVED_CHANGES_HEADING: "Unsaved Changes!",
  UNSAVED_CHANGES_PARA: "You have not saved your changes, do you want to continue",
};

// Helpdesk canned responses messages
export const HELPDESK_CANNED_MESSAGES = {
  UPDATED: "Canned response updated successfully!",
  NOT_FOUND: "Canned response not found!",
  FOLDER_REQUIRED: "Folder is required",
  BODY_REQUIRED: "The response needs some text",
  AUDIENCE_REQUIRED: "Choose at least one party it may be sent to",
  PLAIN_TEXT_ONLY: "Plain text only — remove the HTML",
  TOO_LONG: (max: number) => `Keep responses under ${max} characters`,
  unknownField: (label: string) => `Unknown field {${label}} — use the Insert field chips`,
  lockedField: (label: string, audience: string) => `{${label}} can’t go in a response that may reach ${audience}`,
};

// Helpdesk tags messages
export const HELPDESK_TAG_MESSAGES = {
  RENAMED: "Tag renamed successfully!",
  MERGED: "Tags merged successfully!",
  NAME_REQUIRED: "Tag name is required",
  NAME_TAKEN: "A tag with this name already exists",
  NOT_A_CATEGORY: "Tags are for categories — order numbers, references and notes go elsewhere on the ticket",
  TAG_NOT_FOUND: "Tag not found!",
  MERGE_NEEDS_TWO: "Select at least two tags to merge!",
};

// Helpdesk ticket statuses & priorities messages
export const HELPDESK_TICKET_MESSAGES = {
  // The stories' exact toasts (always shown, whatever the API's own message says).
  STATUS_CREATED: "New status created successfully!",
  STATUS_UPDATED: "Status updated successfully!",
  PRIORITY_CREATED: "New priority created successfully!",
  PRIORITY_UPDATED: "Priority updated successfully!",
  // Decisions D46 / D49: moving a default (our wording, whatever the API's own message says).
  DEFAULT_STATUS_UPDATED: "Default status updated successfully!",
  DEFAULT_PRIORITY_UPDATED: "Default priority updated successfully!",
  // Decision D55: switching a status / priority on or off (our wording, whatever the API's own message says).
  STATUS_ACTIVATED: "Status activated successfully!",
  STATUS_DEACTIVATED: "Status deactivated successfully!",
  PRIORITY_ACTIVATED: "Priority activated successfully!",
  PRIORITY_DEACTIVATED: "Priority deactivated successfully!",
  STATUS_NAME_REQUIRED: "Please enter status name",
  STATUS_NAME_TOO_LONG: "Status name must be at most 50 characters",
  PRIORITY_NAME_REQUIRED: "Please enter priority name",
  PRIORITY_NAME_TOO_LONG: "Priority name must be at most 50 characters",
  ICON_REQUIRED: "Please select icon",
  COLOR_REQUIRED: "Please select color code",
};

// Helpdesk notification messages
export const HELPDESK_NOTIFICATION_MESSAGES = {
  // The stories' exact toasts when a setting is saved (always shown, whatever the API's own message says).
  SAVE_SUCCESS: "Notification settings have been saved successfully!",
  SAVE_FAILURE: "Unable to save notification settings. Please try again!",
};

// Helpdesk signatures messages
export const HELPDESK_SIGNATURE_MESSAGES = {
  // Shown when the API sends no message of its own.
  CREATE_SUCCESS: "Signature created successfully!",
  UPDATE_SUCCESS: "Signature updated successfully!",
  NAME_REQUIRED: "Name is required",
  CUSTOMER_LANE_REQUIRED: "Customer lane is required",
  AGENT_LANE_REQUIRED: "Agent lane is required",
  ONE_LANE_REQUIRED: "At least one lane signature is required.",
  PREVIEW_FAILED: "Couldn’t load the preview.",
  UNSAVED_CHANGES_HEADING: "Unsaved Changes!",
  UNSAVED_CHANGES_PARA: "You have not saved your changes, do you want to continue",
};

export const CONVERSATION_MESSAGES = {
  EMAIL_SENT: "Email sent successfully!",
  CLAUDE_HANDED_BACK: "Claude handed this reply back to you!",
  CLAUDE_DRAFT_DISCARDED: "Draft discarded. Claude will use your reason for future drafts.",
  CLAUDE_DRAFT_THROWN_AWAY: "Draft discarded.",
  CLAUDE_DRAFT_CHANGED_ELSEWHERE:
    "This Claude draft was changed on the POD request screen; your text will go out as an ordinary reply.",
  NOTE_ADDED: "Internal note added successfully!",
  THREAD_UPDATED: "Thread updated successfully!",
  THREAD_RESOLVED: "Conversation resolved successfully.",
  THREAD_REOPENED: "Thread reopened",
  EMAIL_MOVED: "Email moved to the other chain",
  EMAIL_SPLIT: "Email split into a new thread",
  ATTACHMENT_FILED: "Attachment filed to the order documents",
  ATTACHMENT_DOWNLOAD_FAILED: "The attachment couldn't be opened. Please try again.",
  RECIPIENT_REQUIRED: "Add at least one recipient",
  INVALID_EMAIL: "Enter a valid email address",
  THREAD_NOT_FOUND: "Thread not found",
  EMAIL_NOT_FOUND: "Email not found",
  MAIL_NOT_SENT: "Mail not sent",
  ATTACHMENT_TYPE: "Only PNG, JPEG, JPG, PDF and Word files can be attached.",
  ATTACHMENT_SIZE: "Each attachment must be 2 MB or smaller.",
};

// Communications › Claude Agents › POD Requests (our wording, whatever the API's own message says)
export const CLAUDE_AGENT_MESSAGES = {
  // The app's table empty state (shared Table), for the tabs without a list yet and empty / failed loads
  NO_RESULTS: "No Results Found!",
  LOAD_FAILED: "Unable to load the POD requests. Please try again!",
  DETAIL_LOAD_FAILED: "Unable to load the POD request. Please try again!",
  SETTINGS_LOAD_FAILED: "Unable to load the POD settings. Please try again!",
  DRAFT_APPROVED: "Mail sent successfully!",
  DRAFT_REGENERATED: "Draft regenerated successfully!",
  DRAFT_DISCARDED: "Draft discarded successfully!",
  DRAFT_SAVED: "Draft saved successfully!",
  DRAFT_ACTION_FAILED: "Unable to update the draft. Please try again!",
  ATTACHMENT_DOWNLOADED: "Attachment downloaded successfully!",
  ATTACHMENT_DOWNLOAD_FAILED: "Unable to download the attachment. Please try again!",
  SETTINGS_SAVED: "POD settings saved successfully!",
  SETTINGS_SAVE_FAILED: "Unable to save the POD settings. Please try again!",
  CHASE_UPDATED: "Chase updated successfully!",
  CHASE_UPDATE_FAILED: "Unable to update the chase. Please try again!",
  CHASE_NAME_REQUIRED: "Please enter chase name",
  CHASE_WHEN_REQUIRED: "Please select when",
  CHASE_TIME_REQUIRED: "Please enter time",
  CHASE_TIME_INVALID: "Please enter a valid time (HH:MM)",
  CHASE_TIME_ZONE_REQUIRED: "Please select time zone",
  CHASE_STOPS_WHEN_REQUIRED: "Please select stops when",
};

// Communications › Claude Agents › Spot Quote settings (our wording, whatever the API's own message says)
export const SPOT_QUOTE_MESSAGES = {
  SETTINGS_LOAD_FAILED: "Unable to load the Spot Quote settings. Please try again!",
  SETTINGS_SAVED: "Spot Quote settings saved successfully!",
  SETTINGS_SAVE_FAILED: "Unable to save the Spot Quote settings. Please try again!",
  CARRIERS_ASKED_REQUIRED: "Please enter carriers asked",
  MARGIN_FLOOR_REQUIRED: "Please enter margin floor",
  MARGIN_FLOOR_INVALID: "Please enter a value from 0 to 100, with up to 2 decimals",
  QUOTE_VALID_REQUIRED: "Please enter quote valid for",
  WHOLE_NUMBER_INVALID: "Please enter a whole number of 1 or more",
  UNSAVED_CHANGES_HEADING: "Unsaved Changes!",
  UNSAVED_CHANGES_PARA: "You have not saved your changes, do you want to continue",
  // Communications › Spot Quotes listing and a round (.claude/sprint63/spot-quotes-listing)
  QUOTE_UPDATE_FAILED: "Unable to update the spot quote. Please try again!",
  ROUND_LOAD_FAILED: "Unable to load the spot quote. Please try again!",
  HUBS_LOAD_FAILED: "Unable to load the nearest carriers. Please try again!",
};

// System Configuration › Helpdesk › Claude Agent Settings (our wording, whatever the API's own message says)
export const CLAUDE_AGENT_SETTINGS_MESSAGES = {
  LOAD_FAILED: "Unable to load the Claude agent settings. Please try again!",
  PERMISSION_UPDATED: "Permission updated successfully!",
  PERMISSION_UPDATE_FAILED: "Unable to update the permission. Please try again!",
  MODEL_UPDATED: "Model updated successfully!",
  MODEL_UPDATE_FAILED: "Unable to update the model. Please try again!",
  SENDING_PAUSED: "Claude sending paused successfully!",
  SENDING_RESUMED: "Claude sending resumed successfully!",
  SENDING_PAUSE_FAILED: "Unable to pause Claude sending. Please try again!",
  SENDING_RESUME_FAILED: "Unable to resume Claude sending. Please try again!",
  PAUSE_TITLE: "Pause Claude Sending!",
  PAUSE_CONFIRM: "Are you sure you want to pause all Claude sending?",
  RESUME_TITLE: "Resume Claude Sending!",
  RESUME_CONFIRM: "Are you sure you want to resume all Claude sending?",
};

export const BULK_UPLOAD_MESSAGES = {
  SUCCESS_UPLOAD: "File uploaded successfully!",
  DOWNLOAD_SUCCESS: "File downloaded successfully!",
  INVALID_FILE_TYPE: "Invalid file type. Only XLSX, CSV, and XLS are allowed.",
  FILE_SIZE_ERROR: "File size must be less than 5 MB.",
  INVALID_EMAIL: "Please enter a valid email",
  ORDER_TYPE_REQUIRED: "Please select an order type.",
  FILE_REQUIRED: "Please upload a valid file.",
  S3_URL_NOT_FOUND: "S3 URL not found in row details",
  SIGNED_URL_ERROR: "Signed URL not returned from server",
};

// Agent scoped import template download messages
export const TEMPLATE_DOWNLOAD_MESSAGES = {
  SUCCESS: "Template downloaded successfully!",
  AGENT_NUMBER_NOT_FOUND:
    "Unable to fetch the agent number, please try again later.",
  HUB_REQUIRED: "Please select an agent hub to download this template.",
  DOWNLOAD_FAILED: "Unable to download the template, please try again later.",
};

// Order Management Messages
export const ORDER_MANAGEMENT_MESSAGES = {
  CUSTOMER_ORDER_CREATE_SUCCESS: "Customer Order created successfully!",
  CUSTOMER_ORDER_UPDATE_SUCCESS: "Customer Order Updated successfully!",
  QUOTE_SAVE_SUCCESS: "Quote Saved Successfully!",
  QUOTE_DELETE_SUCCESS: "Quote Deleted Successfully!",
  ORDERS_FINALIZED_SUCCESS: "Orders finalized successfully!",
  ITEM_DETAIL_DELETE_SUCCESS: "Item detail deleted successfully!",
  OTHER_CHARGES_ADD_SUCCESS: "Other Charges Added Successfully!",
  RECEIVE_INFO_SAVE_SUCCESS: "Receive Information Saved Successfully!",
  DELIVERED_INFO_SAVE_SUCCESS: "Delivered Information Saved Successfully!",
  FIRST_OFFERED_SAVE_SUCCESS: "First Offered Saved Successfully!",
  SCHEDULED_ETA_SAVE_SUCCESS: "Scheduled ETA Saved Successfully!",
  PICKUP_INFO_SAVE_SUCCESS: "Pickup information saved successfully!",
  FIRST_OFFERED_DATE_SAVE_SUCCESS: "First offered date saved successfully!",
  DROPPED_ETA_SAVE_SUCCESS: "Dropped ETA information saved successfully!",
  DROP_INFO_SAVE_SUCCESS: "Drop information saved successfully!",
  FILE_UPLOAD_SUCCESS: "File Uploaded SuccessFully",
  UNITS_REQUIRED_ERROR: "Enter Value",
  ADDITIONAL_CHARGE_REMOVE_SUCCESS: "Additional charge removed successfully!",
  ADDITIONAL_CHARGE_APPLY_SUCCESS: "Additional charges applied successfully!",
  ADDITIONAL_CHARGE_REVIEW_SUCCESS: "Agent cost reviewed successfully!",
  MUTUALLY_EXCLUSIVE_CHARGE_ERROR:
    "Remove & Disposal and Order Swap & Exchange cannot be applied at the same time.",
  REMOVE_CHARGE_CONFIRM_HEADING: "Remove Additional Charge!",
  REMOVE_CHARGE_CONFIRM_PARA: "Do you want to remove the additional charge",
  // Fallback only — the save response's own message is shown when present.
  TRACK_LTL_SAVE_SUCCESS: "LTL shipment status fetched successfully",
  // Fallback only — the checkbol response's own message is shown when present.
  TRACK_LTL_BOL_EXISTS_MESSAGE:
    "The BOL number you entered already exists. Do you still want to proceed?",
};
// Mandatory-field validation on the order / quote screens. The suffix is shared so the
// focus hook can recognise — and clear — only the messages that validation wrote,
// leaving field-level text ("Please enter a valid zip code.") untouched.
export const MANDATORY_SUFFIX = " is mandatory.";
export const HANDLING_UNITS_REQUIRED_MESSAGE =
  "At least one handling unit is required.";
